import { TickSnapshot, TickSnapshotApiResponse } from '@/types/tickSnapshot';
import { apiClient } from './client';

/**
 * Fetch all tick snapshots for market depth analysis
 * @param marketCapFilter - Market cap filter range (e.g., "0-50", "50-500", "500-5000", "above-5000")
 */
export const getTickSnapshots = async (marketCapFilter?: string): Promise<TickSnapshot[]> => {
  try {
    const params: Record<string, string> = {};
    if (marketCapFilter) {
      params.market_cap_filter = marketCapFilter;
    }

    const response = await apiClient.get('/market/tick-snapshots', { params });

    // Handle the API response structure
    const responseData = response.data as TickSnapshotApiResponse;

    // Make sure we have a valid response structure
    if (!responseData.data) {
      console.warn('Unexpected API response structure:', responseData);
      return [];
    }

    return responseData.data || [];
  } catch (error) {
    console.error('Error fetching tick snapshots:', error);
    throw error;
  }
};


/**
 * Fetch filtered tick snapshots based on insight filter type
 * @param filterType - Filter type (e.g., "only_buyers", "only_sellers", "buyer_dominated", etc.)
 */
export const getFilteredTickSnapshots = async (filterType: string): Promise<TickSnapshot[]> => {
  try {
    const params: Record<string, string> = {
      filter_type: filterType,
    };

    const response = await apiClient.get('/market/filtered-tick-snapshots/', { params });

    // Handle the API response structure
    const responseData = response.data as TickSnapshotApiResponse;

    // Make sure we have a valid response structure
    if (!responseData.data) {
      console.warn('Unexpected API response structure:', responseData);
      return [];
    }

    return responseData.data || [];
  } catch (error) {
    console.error('Error fetching filtered tick snapshots:', error);
    throw error;
  }
};
